import React from 'react';
import { Link } from 'react-router-dom';

import icon from 'assets/icon.svg';

const HeaderLogo = () => {
  return (
    <div className="HeaderLogo">
      <Link to="/">
        <img src={icon} alt="logo" />
      </Link>
    </div>
  );
}

export default HeaderLogo;



// WEBPACK FOOTER //
// ./src/components/layouts/LoggedIn/Header/HeaderLogo.js